<template>
  <div style="width: 90vw">
    <el-container style="padding: 25px 25px">


      <div class="bbb1">
        <div class="custom-tabs-container">
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">

            <el-tab-pane label="投放数据" name="first"></el-tab-pane>
            <el-tab-pane label="投放营收数据" name="third"></el-tab-pane>
<!--            <el-tab-pane label="预估倍率" name="4"></el-tab-pane>-->
            <div class="chart-container" v-show="activeName==='4'&&showChart===true">
              <el-select
                  size="mini"
                  class="el-select2"
                  v-model="selectedDays"
                  multiple
                  placeholder="请选择要展示的天数"
                  @change="updateChart"
              >
                <el-option
                    v-for="day in roiDays"
                    :key="day"
                    :label="`${day}日数据`"
                    :value="day"
                />
              </el-select>
              <el-checkbox
                  v-model="showCost"
                  @change="updateChart"
              >显示消耗
              </el-checkbox>

              <!--            <el-checkbox-->
              <!--                v-model="showCost2"-->
              <!--                @change="updateChart"-->
              <!--            >显示实际消耗-->
              <!--            </el-checkbox>-->

              <el-checkbox
                  v-model="showCost3"
                  @change="updateChart"
              >显示利润
              </el-checkbox>
              <div ref="chart" style="width: 100%; height: 500px; position: relative;"></div>

            </div>


            <el-header style="display: flex;height: 40px;">

              <span class="style-title">项目名称:</span>
              <el-select v-model="valueGame" placeholder="游戏选择" size="mini" @change="changeGame()"
                         style="margin-left: 5px;margin-top: 5px;align-items: center;display: flex"
                         filterable clearable>
                <el-option
                    v-for="item in optionsGame"
                    :key="item"
                    :label="item"
                    :value="item">
                </el-option>
              </el-select>

              <span class="style-title">日期:</span>

              <el-date-picker
                  v-model="value2"
                  type="daterange"
                  align="right"
                  unlink-panels
                  style="margin-left: 5px;margin-top: 9px;height:28px;width: 280px;align-items: center;display: flex"
                  size="mini"
                  range-separator="至"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions3">
              </el-date-picker>
              <el-select v-model="gameType" placeholder="品类选择" size="mini"
                         style="margin-left: 5px;margin-top: 5px;align-items: center;display: flex"
                         filterable clearable>
                <el-option
                    v-for="item in uniqueGameTypes"
                    :key="item"
                    :label="item"
                    :value="item">
                </el-option>
              </el-select>
              <el-button size="mini"
                         style="margin-left: 6px;height: 30px;margin-top:8px;background-color: #f4f4f5;color: black"
                         @click="search(true)" icon="el-icon-refresh">
                刷新
              </el-button>

              <el-checkbox-group
                  v-show="activeName!=='4'"
                  class="style-title"
                  v-model="checkedCities"
                  :min="1"
                  :max="3">
                <el-checkbox v-for="city in cities" :label="city" :key="city">{{ city }}</el-checkbox>
              </el-checkbox-group>

              <el-checkbox-group
                  class="style-title"
                  v-show="activeName==='4'"
                  v-model="checkedYugu"
                  :min="1"
                  :max="3">
                <el-checkbox v-for="city in citiesYugu" :label="city" :key="city">{{ city }}</el-checkbox>
              </el-checkbox-group>

              <el-checkbox-group
                  class="style-title"

                  v-model="checkedCities2"
                  :min="1"
                  :max="3">
                <el-checkbox v-for="city in cities2" :label="city" :key="city">{{ city }}</el-checkbox>
              </el-checkbox-group>
              <el-checkbox
                  v-model="showChart"
                  v-show="activeName==='4'"
                  style="margin-left: 16px;height: 30px;margin-top:12px;"
              >显示图表
              </el-checkbox>

              <!-- 添加列筛选按钮 -->
              <el-dropdown trigger="click" @command="toggleColumn" style="margin-left: 16px;height: 30px;margin-top:8px;">
                <el-button size="mini">
                  列筛选<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                      v-for="col in allColumns"
                      :key="col.prop"
                      :command="col.prop"
                      :disabled="visibleColumns.length === 1 && visibleColumns.includes(col.prop)">
                    <el-checkbox
                        :value="visibleColumns.includes(col.prop)"
                        @change="() => toggleColumn(col.prop)"                  style="margin-right: 8px;">
                    </el-checkbox>
                    {{ col.label }}
                  </el-dropdown-item>
                  <el-dropdown-item divided>
                    <el-button @click="resetColumns" type="text">重置列</el-button>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-header>

            <!--        营收数据-->
            <el-table
                ref="tableData1"
                v-show="activeName==='third'"
                :data="tableData"
                stripe
                border
                max-height="80vh"
                height="79vh"
                style="margin-top: 11px"
                :header-cell-style="{background:'rgba(244,244,245,0)',color:'#323335'}"
                size="mini"
                v-loading="loading"
                highlight-current-row

            >

              <el-table-column
                  align="center"
                  type="selection"
                  width="44">
              </el-table-column>


              <el-table-column
                  prop="uploadDate"
                  label="日期"
                  sortable
                  min-width="100"
                  v-if="checkedCities.indexOf('日期')>-1"
              >

              </el-table-column>

              <el-table-column
                  prop="gameName"
                  label="游戏名称"
                  min-width="140"
                  v-if="checkedCities.indexOf('游戏名')>-1"
              >
              </el-table-column>

              <el-table-column
                  prop="profit"
                  label="利润(元)"
                  min-width="120"
                  sortable
                  :formatter="value_format"
              >

                <template slot-scope="{row}">

                <span style="color: #d65055"
                      v-if="(row.incomBefore+row.adBi-row.adConsume)>0">{{
                    row.incomBefore + row.adBi - row.adConsume |dataFilters
                  }}
</span>
                  <span v-else
                        style="color: #5daf34">{{
                      row.incomBefore + row.adBi - row.adConsume|dataFilters
                    }}
</span>
                </template>

              </el-table-column>


              <el-table-column
                  prop="adConsume"
                  label="账面消耗(元)"
                  min-width="120"
                  sortable
                  :formatter="value_format2"
              >

              </el-table-column>

              <el-table-column
                  prop="incomBefore"
                  label="流量主收入(元)分成后"
                  min-width="120"
                  :formatter="value_format2"
              >

              </el-table-column>

              <el-table-column
                  prop="adBi"
                  label="广告金(元)"
                  min-width="120"
                  :formatter="value_format2"
              >

              </el-table-column>

              <el-table-column
                  prop="fd_income"
                  label="返点(元)"
                  min-width="120"
                  :formatter="value_format2"
              >

              </el-table-column>

              <el-table-column
                  prop="f8"
                  label="框返(元)"
                  min-width="120"
                  :formatter="value_format2"
              >

              </el-table-column>

              <el-table-column
                  prop="jl_zc"
                  label="外部购入广告金收入(元)"
                  min-width="160"
              >

              </el-table-column>


            </el-table>

            <!--        投放数据-->
            <el-table
                ref="tableData1"
                v-show="activeName==='first'"
                :data="tableData"
                stripe
                border
                max-height="80vh"
                height="79vh"
                style="margin-top: 11px"
                :header-cell-style="{background:'rgba(244,244,245,0)',color:'#323335'}"
                size="mini"
                v-loading="loading"
                highlight-current-row

            >

              <el-table-column
                  align="center"
                  type="selection"
                  width="44">
              </el-table-column>


              <el-table-column
                  prop="uploadDate"
                  label="日期"
                  sortable
                  min-width="100"
                  v-if="checkedCities.indexOf('日期')>-1"
              >

              </el-table-column>

              <el-table-column
                  prop="gameName"
                  label="游戏名称"
                  min-width="180"
                  v-if="checkedCities.indexOf('游戏名')>-1"
              >
              </el-table-column>


              <!--          ✔-->
              <el-table-column
                  prop="adConsume"
                  label="账面消耗(元)"
                  min-width="160"
                  sortable
                  :formatter="value_format2"
              >

              </el-table-column>


              <!--          ✔-->
              <el-table-column
                  prop="costAmout"
                  label="现金消耗(元)"
                  min-width="160"
                  sortable
                  :formatter="value_format2"
              >

              </el-table-column>
              <!--          ✔-->
              <el-table-column
                  prop="costAmout"
                  label="非现金消耗(元)"
                  min-width="160"
                  sortable
                  :formatter="value_format2"
              >
                <template slot-scope="{row}">

                  {{ row.adConsume - row.costAmout|dataFilters }}

                </template>

              </el-table-column>


              <el-table-column
                  prop="ygProfit"
                  label="预估利润（元）含广告金"
                  min-width="180"
                  :formatter="value_format2"
              >

              </el-table-column>


              <el-table-column
                  prop="实时利润"
                  label="实时利润（元）含广告金"
                  min-width="180"
                  :formatter="value_format2"
              >

              </el-table-column>
              <el-table-column
                  prop="ygROI"
                  label="预估终身ROI（含广告金）"
                  min-width="180"
                  :formatter="value_format4"
              >

              </el-table-column>
              <el-table-column
                  prop="实时roi"
                  label="实时ROI（含广告金）"
                  min-width="160"
                  :formatter="value_format4"
              >

              </el-table-column>
              <el-table-column
                  prop="首日roi"
                  label="首日ROI（含广告金）"
                  min-width="160"
                  :formatter="value_format4"
              >

              </el-table-column>

              <el-table-column
                  prop=""
                  label="首日广告金占比"
                  min-width="160"
                  :formatter="value_format2"
              >

              </el-table-column>

              <el-table-column
                  prop="adRoi150"
                  label="预估终身倍率"
                  min-width="160"

              >

              </el-table-column>
              <el-table-column
                  prop="实时倍率"
                  label="实时倍率"
                  min-width="160"
                  :formatter="value_format5"
              >

              </el-table-column>
              <el-table-column
                  prop=""
                  label="广告金剩余(元)"
                  min-width="160"
                  :formatter="value_format2"
              >

              </el-table-column>


            </el-table>
          </el-tabs>
        </div>



        <!--        //预估倍率-->
<!--        <el-table-->
<!--            ref="tableData1"-->
<!--            v-show="activeName==='4'"-->
<!--            :data="tableDataY4"-->
<!--            max-height="80vh"-->
<!--            height="79vh"-->
<!--            style="margin-top: 11px"-->
<!--            :header-cell-style="{background:'rgba(244,244,245,0)',color:'#323335'}"-->
<!--            size="mini"-->
<!--            :default-sort="{prop: 'uploadDate', order: 'descending'}"-->
<!--            v-loading="loading"-->
<!--            highlight-current-row-->
<!--            @sort-change="customSort"-->
<!--        >-->

<!--          &lt;!&ndash; 在预估倍率表格中修改列的显示控制 &ndash;&gt;-->
<!--          <el-table-column-->
<!--              prop="uploadDate"-->
<!--              label="日期"-->
<!--              sortable-->
<!--              :sort-orders="['descending', 'ascending']"-->
<!--              min-width="130"-->
<!--              v-if="isColumnVisible('uploadDate')">-->
<!--          </el-table-column>-->

<!--          <el-table-column-->
<!--              prop="gameType"-->
<!--              label="品类"-->
<!--              min-width="120"-->
<!--              v-if="isColumnVisible('gameType')">-->
<!--          </el-table-column>-->

<!--          <el-table-column-->
<!--              prop="gameName"-->
<!--              label="游戏名称"-->
<!--              min-width="180"-->
<!--              v-if="isColumnVisible('gameName')">-->
<!--          </el-table-column>-->

<!--          <el-table-column-->
<!--              prop="statCost"-->
<!--              label="消耗"-->
<!--              min-width="140"-->
<!--              v-if="isColumnVisible('statCost')">-->
<!--            <template slot-scope="{row}">-->
<!--              {{ row.statCost|dataFilters2 }}-->
<!--            </template>-->
<!--          </el-table-column>-->

<!--          <el-table-column-->
<!--              prop="profit"-->
<!--              label="预估利润"-->
<!--              min-width="140"-->
<!--              v-if="isColumnVisible('profit')">-->
<!--            <template slot-scope="{row}">-->
<!--    <span :class="((Math.max(row.roi3, row.roi7, row.roi15, row.roi30, row.roi45, row.roi60, row.roi75, row.roi90) * row.roi0 - 1) * (row.statCost ))>0?'red':'green'">-->
<!--      {{-->
<!--        ((Math.max(row.roi3, row.roi7, row.roi15, row.roi30, row.roi45, row.roi60, row.roi75, row.roi90) * row.roi0 - 1) * (row.statCost)).toFixed(2)-->
<!--      }}-->
<!--    </span>-->
<!--            </template>-->
<!--          </el-table-column>-->

<!--          <el-table-column-->
<!--              prop="roi3"-->
<!--              label="预估ROI|倍率"-->
<!--              min-width="150"-->
<!--              v-if="isColumnVisible('roiInfo')">-->
<!--            <template slot-scope="{row}">-->
<!--    <span style="color: #3a8ee6">-->
<!--      {{-->
<!--        (Math.max(row.roi3, row.roi7, row.roi15, row.roi30, row.roi45, row.roi60, row.roi75, row.roi90) * row.roi0 * 100).toFixed(2) + '%'-->
<!--      }}-->
<!--    </span>|-->
<!--              <span style="color: #d65055">{{-->
<!--                  Math.max(row.roi3, row.roi7, row.roi15, row.roi30, row.roi45, row.roi60, row.roi75, row.roi90)|dataFilters2-->
<!--                }}</span>-->
<!--            </template>-->
<!--          </el-table-column>-->

<!--          <el-table-column-->
<!--              prop="maxNonZeroDay"-->
<!--              label="预估周期"-->
<!--              min-width="80"-->
<!--              v-if="isColumnVisible('maxNonZeroDay')">-->
<!--            <template slot-scope="{row}">-->
<!--              {{ getMaxNonZeroDay(row) }}-->
<!--            </template>-->
<!--          </el-table-column>-->

<!--          <el-table-column-->
<!--              prop="roi0"-->
<!--              label="1日ROI"-->
<!--              min-width="120"-->
<!--              v-if="isColumnVisible('roi0')">-->
<!--            <template slot-scope="{row}">-->
<!--              {{ (row.roi0 * 100).toFixed(2) + '%' }}-->
<!--            </template>-->
<!--          </el-table-column>-->

<!--          <el-table-column-->
<!--              prop="roi2"-->
<!--              label="2日ROI"-->
<!--              min-width="130"-->
<!--              v-if="visibleColumns.includes('roi2')"-->
<!--          >-->
<!--            <template slot-scope="{row}">-->
<!--              &lt;!&ndash; ROI显示部分 &ndash;&gt;-->
<!--              <span v-show="checkedCities2.includes('ROI')">-->
<!--      <span-->
<!--          :class="row.descType <= 2 ? 'yugu2' : ''"-->
<!--          v-if="row.descType <= 2"-->
<!--      >-->
<!--        {{ `  ${(row.roi2 * row.roi0 * 100).toFixed(2)}%` }}-->
<!--      </span>-->
<!--      <span v-else>-->
<!--        {{ `  ${(row.roi2 * row.roi0 * 100).toFixed(2)}%` }}-->
<!--      </span>-->
<!--    </span>-->
<!--              &lt;!&ndash; 分隔符 &ndash;&gt;-->
<!--              <span v-show="checkedCities2.includes('倍率') && checkedCities2.includes('ROI')">|</span>-->
<!--              &lt;!&ndash; 倍率显示部分 &ndash;&gt;-->
<!--              <span v-show="checkedCities2.includes('倍率')">-->
<!--      <span-->
<!--          :class="row.descType <= 2 ? 'yugu' : ''"-->
<!--          v-if="row.descType <= 2"-->
<!--      >-->
<!--        {{ row.roi2 | dataFilters2 }}-->
<!--      </span>-->
<!--      <span v-else>-->
<!--        {{ row.roi2 | dataFilters2 }}-->
<!--      </span>-->
<!--    </span>-->
<!--              <i-->
<!--                  v-if="row.repairedColumns && typeof row.repairedColumns === 'string' && (',' + row.repairedColumns + ',').includes(',roi2,')"-->
<!--                  class="el-icon-star-on updated-marker-icon"-->
<!--                  title="根据品类分组预估">-->
<!--              </i>-->
<!--            </template>-->
<!--          </el-table-column>-->

<!--          &lt;!&ndash; 第3日ROI独立列 &ndash;&gt;-->
<!--          <el-table-column-->
<!--              prop="roi3"-->
<!--              label="3日ROI"-->
<!--              min-width="150"-->
<!--              v-if="visibleColumns.includes('roi3')"-->
<!--          >-->
<!--            <template slot-scope="{row}">-->
<!--              &lt;!&ndash; ROI显示部分 &ndash;&gt;-->
<!--              <span v-show="checkedCities2.includes('ROI')">-->
<!--      <span-->
<!--          :class="row.descType <= 3 ? 'yugu2' : ''"-->
<!--          v-if="row.descType <= 3"-->
<!--      >-->
<!--        {{ `  ${(row.roi3 * row.roi0 * 100).toFixed(2)}%` }}-->
<!--      </span>-->
<!--      <span v-else>-->
<!--        {{ `  ${(row.roi3 * row.roi0 * 100).toFixed(2)}%` }}-->
<!--      </span>-->
<!--    </span>-->
<!--              &lt;!&ndash; 分隔符 &ndash;&gt;-->
<!--              <span v-show="checkedCities2.includes('倍率') && checkedCities2.includes('ROI')">|</span>-->
<!--              &lt;!&ndash; 倍率显示部分 &ndash;&gt;-->
<!--              <span v-show="checkedCities2.includes('倍率')">-->
<!--      <span-->
<!--          :class="row.descType <= 3 ? 'yugu' : ''"-->
<!--          v-if="row.descType <= 3"-->
<!--      >-->
<!--        {{ row.roi3 | dataFilters2 }}-->
<!--      </span>-->
<!--      <span v-else>-->
<!--        {{ row.roi3 | dataFilters2 }}-->
<!--      </span>-->
<!--    </span>-->
<!--              <i-->
<!--                  v-if="row.repairedColumns && typeof row.repairedColumns === 'string' && (',' + row.repairedColumns + ',').includes(',roi3,')"-->
<!--                  class="el-icon-star-on updated-marker-icon"-->
<!--                  title="根据品类分组预估">-->
<!--              </i>-->
<!--            </template>-->
<!--          </el-table-column>-->

<!--          &lt;!&ndash; 第4日ROI独立列 &ndash;&gt;-->
<!--          <el-table-column-->
<!--              prop="roi4"-->
<!--              label="4日ROI"-->
<!--              min-width="150"-->
<!--              v-if="visibleColumns.includes('roi4')"-->
<!--          >-->
<!--            <template slot-scope="{row}">-->
<!--              &lt;!&ndash; ROI显示部分 &ndash;&gt;-->
<!--              <span v-show="checkedCities2.includes('ROI')">-->
<!--      <span-->
<!--          :class="row.descType <= 4 ? 'yugu2' : ''"-->
<!--          v-if="row.descType <= 4"-->
<!--      >-->
<!--        {{ `  ${(row.roi4 * row.roi0 * 100).toFixed(2)}%` }}-->
<!--      </span>-->
<!--      <span v-else>-->
<!--        {{ `  ${(row.roi4 * row.roi0 * 100).toFixed(2)}%` }}-->
<!--      </span>-->
<!--    </span>-->
<!--              &lt;!&ndash; 分隔符 &ndash;&gt;-->
<!--              <span v-show="checkedCities2.includes('倍率') && checkedCities2.includes('ROI')">|</span>-->
<!--              &lt;!&ndash; 倍率显示部分 &ndash;&gt;-->
<!--              <span v-show="checkedCities2.includes('倍率')">-->
<!--      <span-->
<!--          :class="row.descType <= 4 ? 'yugu' : ''"-->
<!--          v-if="row.descType <= 4"-->
<!--      >-->
<!--        {{ row.roi4 | dataFilters2 }}-->
<!--      </span>-->
<!--      <span v-else>-->
<!--        {{ row.roi4 | dataFilters2 }}-->
<!--      </span>-->
<!--    </span>-->
<!--              <i-->
<!--                  v-if="row.repairedColumns && typeof row.repairedColumns === 'string' && (',' + row.repairedColumns + ',').includes(',roi4,')"-->
<!--                  class="el-icon-star-on updated-marker-icon"-->
<!--                  title="根据品类分组预估">-->
<!--              </i>-->
<!--            </template>-->
<!--          </el-table-column>-->

<!--          &lt;!&ndash; 第5日ROI独立列 &ndash;&gt;-->
<!--          <el-table-column-->
<!--              prop="roi5"-->
<!--              label="5日ROI"-->
<!--              min-width="150"-->
<!--              v-if="visibleColumns.includes('roi5')"-->
<!--          >-->
<!--            <template slot-scope="{row}">-->
<!--              &lt;!&ndash; ROI显示部分 &ndash;&gt;-->
<!--              <span v-show="checkedCities2.includes('ROI')">-->
<!--      <span-->
<!--          :class="row.descType <= 5 ? 'yugu2' : ''"-->
<!--          v-if="row.descType <= 5"-->
<!--      >-->
<!--        {{ `  ${(row.roi5 * row.roi0 * 100).toFixed(2)}%` }}-->
<!--      </span>-->
<!--      <span v-else>-->
<!--        {{ `  ${(row.roi5 * row.roi0 * 100).toFixed(2)}%` }}-->
<!--      </span>-->
<!--    </span>-->
<!--              &lt;!&ndash; 分隔符 &ndash;&gt;-->
<!--              <span v-show="checkedCities2.includes('倍率') && checkedCities2.includes('ROI')">|</span>-->
<!--              &lt;!&ndash; 倍率显示部分 &ndash;&gt;-->
<!--              <span v-show="checkedCities2.includes('倍率')">-->
<!--      <span-->
<!--          :class="row.descType <= 5 ? 'yugu' : ''"-->
<!--          v-if="row.descType <= 5"-->
<!--      >-->
<!--        {{ row.roi5 | dataFilters2 }}-->
<!--      </span>-->
<!--      <span v-else>-->
<!--        {{ row.roi5 | dataFilters2 }}-->
<!--      </span>-->
<!--    </span>-->
<!--              <i-->
<!--                  v-if="row.repairedColumns && typeof row.repairedColumns === 'string' && (',' + row.repairedColumns + ',').includes(',roi5,')"-->
<!--                  class="el-icon-star-on updated-marker-icon"-->
<!--                  title="根据品类分组预估">-->
<!--              </i>-->
<!--            </template>-->
<!--          </el-table-column>-->

<!--          &lt;!&ndash; 第6日ROI独立列 &ndash;&gt;-->
<!--          <el-table-column-->
<!--              prop="roi6"-->
<!--              label="6日ROI"-->
<!--              min-width="150"-->
<!--              v-if="visibleColumns.includes('roi6')"-->
<!--          >-->
<!--            <template slot-scope="{row}">-->
<!--              &lt;!&ndash; ROI显示部分 &ndash;&gt;-->
<!--              <span v-show="checkedCities2.includes('ROI')">-->
<!--      <span-->
<!--          :class="row.descType <= 6 ? 'yugu2' : ''"-->
<!--          v-if="row.descType <= 6"-->
<!--      >-->
<!--        {{ `  ${(row.roi6 * row.roi0 * 100).toFixed(2)}%` }}-->
<!--      </span>-->
<!--      <span v-else>-->
<!--        {{ `  ${(row.roi6 * row.roi0 * 100).toFixed(2)}%` }}-->
<!--      </span>-->
<!--    </span>-->
<!--              &lt;!&ndash; 分隔符 &ndash;&gt;-->
<!--              <span v-show="checkedCities2.includes('倍率') && checkedCities2.includes('ROI')">|</span>-->
<!--              &lt;!&ndash; 倍率显示部分 &ndash;&gt;-->
<!--              <span v-show="checkedCities2.includes('倍率')">-->
<!--      <span-->
<!--          :class="row.descType <= 6 ? 'yugu' : ''"-->
<!--          v-if="row.descType <= 6"-->
<!--      >-->
<!--        {{ row.roi6 | dataFilters2 }}-->
<!--      </span>-->
<!--      <span v-else>-->
<!--        {{ row.roi6 | dataFilters2 }}-->
<!--      </span>-->
<!--    </span>-->
<!--              <i-->
<!--                  v-if="row.repairedColumns && typeof row.repairedColumns === 'string' && (',' + row.repairedColumns + ',').includes(',roi6,')"-->
<!--                  class="el-icon-star-on updated-marker-icon"-->
<!--                  title="根据品类分组预估">-->
<!--              </i>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          &lt;!&ndash; 多日ROI列 &ndash;&gt;-->
<!--          <template v-for="(day) in roiDays">-->
<!--            <el-table-column-->
<!--                v-if="isColumnVisible('roiColumns')"-->
<!--                :key="day"-->
<!--                :prop="'roi' + day"-->
<!--                :label="`${day}日ROI`"-->
<!--                min-width="150">-->
<!--              <template slot-scope="{row}">-->
<!--                &lt;!&ndash; ROI显示部分 &ndash;&gt;-->
<!--                <span v-show="checkedCities2.includes('ROI')">-->
<!--             <span-->
<!--                 :class="row.descType <=day ? 'yugu2' : ''"-->
<!--                 v-if="row.descType <=day"-->
<!--             >-->
<!--          {{ `  ${(row[`roi${day}`] * row.roi0 * 100).toFixed(2)}%` }}-->
<!--        </span>-->
<!--        <span v-else>-->
<!--          {{ `  ${(row[`roi${day}`] * row.roi0 * 100).toFixed(2)}%` }}-->
<!--        </span>-->
<!--      </span>-->
<!--                &lt;!&ndash; 分隔符 &ndash;&gt;-->
<!--                <span v-show="checkedCities2.includes('倍率') && checkedCities2.includes('ROI')">|</span>-->
<!--                &lt;!&ndash; 倍率显示部分 &ndash;&gt;-->
<!--                <span v-show="checkedCities2.includes('倍率')">-->
<!--            <span-->
<!--                :class="row.descType <=day ? 'yugu' : ''"-->
<!--                v-if="row.descType <=day"-->
<!--            >-->
<!--          {{ row[`roi${day}`] | dataFilters2 }}-->
<!--        </span>-->
<!--        <span v-else>-->
<!--          {{ row[`roi${day}`] | dataFilters2 }}-->
<!--        </span>-->
<!--        <i-->
<!--            v-if="Array.isArray(row.updatedFields) && row.updatedFields.includes(`roi${day}`)"-->
<!--            class="el-icon-star-on updated-marker-icon"-->
<!--            title="根据品类预估">-->
<!--        </i>-->
<!--      </span>-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--          </template>-->


<!--          <el-table-column-->
<!--              prop="groupLabel"-->
<!--              label="标签"-->
<!--              min-width="150"-->
<!--              v-if="isColumnVisible('groupLabel')">-->
<!--          </el-table-column>-->



<!--        </el-table>-->
<!--        <el-pagination-->

<!--            layout="total"-->
<!--            :total="tableData.length">-->
<!--        </el-pagination>-->
      </div>


    </el-container>

  </div>
</template>
<script>
const cityOptions = ['游戏名', '日期'];
const cityOptions2 = ['ROI', '倍率'];
const cityOptions3 = ['游戏名', '日期'];
export default {
  name: "ToufangWxBroad",

  data() {

    return {
      showChart: false,
      selectedDays: [3, 7],
      gameType: '',
      chart: null,
      showCost3: false,
      showCost: false,
      showCost2: false,
      checkedYugu: ['日期'],
      citiesYugu: cityOptions3,
      chartOptions: {
        tooltip: {
          trigger: 'axis',

          axisPointer: {type: 'cross'},
          formatter: params => {

            let res = params[0].axisValue + '<br>'
            params.forEach(item => {
              const color = String(item.color || '#666') // 安全转换颜色值
              res += `
        <span style="display:inline-block;margin-right:5px;border-radius:10px;
          width:10px;height:10px;background-color:${color};"></span>
        ${item.seriesName}: ${item.value}${item.seriesType === 'cost' ? '元' : ''}
      `
              if (item.seriesName.includes('ROI')) res += '%'
              res += '<br>'
            })
            return res
          }
        },
        legend: {
          data: [],
          bottom: 0,
          left: 'center',
          type: 'scroll'
        }, grid: {
          left: '5%',
          right: '5%'
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLabel: {
            rotate: 45,
            formatter: value => {
              const date = new Date(value)
              return `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`
            }
          }
        },
        yAxis: [
          { // ROI轴
            type: 'value',
            name: 'ROI (%)',
            position: 'left',

            axisLabel: {formatter: '{value}%'}
          },
          { // 倍率轴
            type: 'value',
            name: '倍率',
            position: 'right',
            offset: 30,
            axisLine: {
              show: true,
              lineStyle: {color: '#68b1fc'}
            }
          },
          { // 消耗轴
            type: 'value',
            name: '消耗 (元)',
            position: 'right',
            offset: 80,
            axisLine: {
              show: true,
              lineStyle: {color: '#f56a6a'}
            }
          },
          // ,
          // { // 消耗轴
          //   type: 'value',
          //   name: '实际消耗 (元)',
          //   position: 'right',
          //   offset: 140,
          //   axisLine: {
          //     show: true,
          //     lineStyle: { color: '#FF5722' }
          //   }
          // }
        ],
        series: []
      },
      dialogFormVisible: false,
      checkedCities: ['游戏名', '日期'],
      activeName: '4',
      value5: '',
      cities: cityOptions,
      cities2: cityOptions2,
      isSort: true,
      list: [],
      value1: [],
      currentPage: 1,
      options3: ['流量主比例', '广告金比例', '返点比例', '框返比例'],
      valueScene: '',
      fl: false,
      loading: false,
      registerDate: "",
      type: 'pv',

      checkedCities2: ['ROI', '倍率'],
      valueUser: "",
      avgEcpm: 0,
      tableDataY4: [],
      roiDays: [ 7, 15, 30, 45, 60, 75, 90],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      }, pickerOptions3: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      }, pickerOptions2: {
        disabledDate(date) {
          return date.getTime() >= Date.now() - 8.64e7;  //只能选择今天及今天之后的日期，如果没有后面的-8.64e7就是今天也不能选
        }
      },
      tableDataType: [],
      tableData: [],
      tableData2: [],
      optionsGame: [],
      valueGame: "",
      value: 0,
      value2: '',
      value3: 7
      , json_data: [{'name': '游戏1', 'date': '2025-02-12', 'jl': 1, 'pf': 2}]
      , json_fields: {
        '游戏名称': 'name',
        '日期': 'date',
        '激励政策收入': 'jl',
        '平台赔付': 'pf'

      },
      height: 800,
      arr1: [],
      arr2: [],
      valueGame2: '',
      items: ["7", "15", "30", "45", "60", "75", "90", "105", "120", "135", "150"],
      isSearch: true,
      form: {
        allDivisionScale: 0,
        divisionScale: 0.1,
        type: '流量主比例',
        date: [],
        checked: true
      },
      formLabelWidth: '140px',
      allColumns: [
        { prop: 'uploadDate', label: '日期' },
        { prop: 'gameType', label: '品类' },
        { prop: 'gameName', label: '游戏名称' },
        { prop: 'statCost', label: '消耗' },
        { prop: 'profit', label: '预估利润' },
        { prop: 'roiInfo', label: '预估ROI|倍率' },
        { prop: 'maxNonZeroDay', label: '预估周期' },
        { prop: 'roi0', label: '1日ROI' },
        { prop: 'roi2', label: '2日ROI' },
        { prop: 'roi3', label: '3日ROI' },
        { prop: 'roi4', label: '4日ROI' },
        { prop: 'roi5', label: '5日ROI' },
        { prop: 'roi6', label: '6日ROI' },

        { prop: 'roiColumns', label: '多日ROI' },
        { prop: 'groupLabel', label: '标签' }
        ],   visibleColumns: [
        'uploadDate', 'gameType', 'gameName', 'statCost', 'profit',
        'roiInfo', 'maxNonZeroDay', 'roi0','roi1','roi2','roi3','roi4', 'roi5','roi6','roiColumns', 'groupLabel'
      ],

    }


  }, computed: {
    uniqueGameTypes() {
      // 从 tableData 中提取唯一的 gameType 值
      const gameTypes = this.tableDataType
          .map(item => item.gameType)
          .filter(type => type !== undefined && type !== null && type !== '');

      // 使用 Set 去重
      return [...new Set(gameTypes)];
    }

  }, watch: {

    colOptions(valArr) {
      // alert("sss");
      this.$nextTick(() => {
        this.$refs.tableDataRef.doLayout();
      });
    }
  }, filters: {
    dataFilters2(value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return "-"

      } else {

        return value.toFixed(2)

      }
    },
    dataFilters(value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return '-'

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }

    }
  }, methods: {
    getMaxNonZeroDay(row) {
      let maxDay = 0;
      // 遍历所有 roiDays，找到最大的不为0的天数
      for (let i = this.roiDays.length - 1; i >= 0; i--) {
        const day = this.roiDays[i];
        if (row[`roi${day}`] !== 0 && row[`roi${day}`] !== undefined) {
          maxDay = day;
          break;
        }
      }
      return maxDay > 0 ? maxDay : '-';
    },
    groupData(data) {

      if (this.checkedYugu.includes("游戏名")) {

        console.log("需要游戏名")

        return data;
      }

      console.log("待处理:", data);

      // 如果没有数据，直接返回空数组
      if (!data || data.length === 0) {
        return [];
      }

      // 使用 reduce 进行分组和求和
      const grouped = data.reduce((acc, item) => {
        // 获取游戏类型
        const gameType = item.gameType
            ? item.gameType
            : '未知类型';
        const uploadDate = item.uploadDate || '未知日期';
        const groupKey = `${gameType}_${uploadDate}`;

        // 如果该类型还没有在累加器中，则初始化
        if (!acc[groupKey]) {
          acc[groupKey] = {
            gameName: `${gameType}(合计)`,
            gameType: gameType,
            descType: 0,
            uploadDate: uploadDate,
            yuDate: '',
            statCost: 0,
            pfAmount: 0,
            roi0: 0,
            roi1: 0,
            roi2: 0,
            roi3: 0,
            roi4: 0,
            roi5: 0,
            roi6: 0,
            roi7: 0,
            roi15: 0,
            roi30: 0,
            roi45: 0,
            roi60: 0,
            roi75: 0,
            roi90: 0,
            roi105: 0,
            roi120: 0,
            roi135: 0,
            roi150: 0,
            // 用于计算加权平均的权重
            statCostSum: 0,
            count: 0
          };
        }

        // 累加数值字段
        const group = acc[groupKey];
        group.statCost += item.statCost || 0;
        group.pfAmount += item.pfAmount || 0;
        group.descType = item.descType;
        // 累加用于计算加权平均的总消耗
        group.statCostSum += item.statCost || 0;
        group.count += 1;

        // 累加ROI数据（后续需要计算加权平均）
        group.roi0 += (item.roi0 || 0) * (item.statCost || 0);
        group.roi2 += (item.roi2 * item.roi0 || 0) * (item.statCost || 0);
        group.roi3 += (item.roi3 * item.roi0 || 0) * (item.statCost || 0);
        group.roi4 += (item.roi4 * item.roi0 || 0) * (item.statCost || 0);
        group.roi5 += (item.roi5 * item.roi0 || 0) * (item.statCost || 0);
        group.roi6 += (item.roi6 * item.roi0 || 0) * (item.statCost || 0);

        group.roi7 += (item.roi7 * item.roi0 || 0) * (item.statCost || 0);
        group.roi15 += (item.roi15 * item.roi0 || 0) * (item.statCost || 0);
        group.roi30 += (item.roi30 * item.roi0 || 0) * (item.statCost || 0);
        group.roi45 += (item.roi45 * item.roi0 || 0) * (item.statCost || 0);
        group.roi60 += (item.roi60 * item.roi0 || 0) * (item.statCost || 0);
        group.roi75 += (item.roi75 * item.roi0 || 0) * (item.statCost || 0);
        group.roi90 += (item.roi90 * item.roi0 || 0) * (item.statCost || 0);
        group.roi105 += (item.roi105 * item.roi0 || 0) * (item.statCost || 0);
        group.roi120 += (item.roi120 * item.roi0 || 0) * (item.statCost || 0);
        group.roi135 += (item.roi135 * item.roi0 || 0) * (item.statCost || 0);
        group.roi150 += (item.roi150 * item.roi0 || 0) * (item.statCost || 0);

        return acc;
      }, {});

      // 计算加权平均值并转换为数组
      const result = Object.values(grouped).map(group => {
        // 只有当总消耗大于0时才计算加权平均
        if (group.statCostSum > 0) {
          group.roi0 = group.roi0 / group.statCostSum;
          group.roi1 = group.roi1 / group.statCostSum / group.roi0;
          group.roi2 = group.roi2 / group.statCostSum / group.roi0;
          group.roi3 = group.roi3 / group.statCostSum / group.roi0;
          group.roi4 = group.roi4 / group.statCostSum / group.roi0;
          group.roi5 = group.roi5 / group.statCostSum / group.roi0;
          group.roi6 = group.roi6 / group.statCostSum / group.roi0;
          group.roi7 = group.roi7 / group.statCostSum / group.roi0;
          group.roi15 = group.roi15 / group.statCostSum / group.roi0;
          group.roi30 = group.roi30 / group.statCostSum / group.roi0;
          group.roi45 = group.roi45 / group.statCostSum / group.roi0;
          group.roi60 = group.roi60 / group.statCostSum / group.roi0;
          group.roi75 = group.roi75 / group.statCostSum / group.roi0;
          group.roi90 = group.roi90 / group.statCostSum / group.roi0;
          group.roi105 = group.roi105 / group.statCostSum / group.roi0;
          group.roi120 = group.roi120 / group.statCostSum / group.roi0;
          group.roi135 = group.roi135 / group.statCostSum / group.roi0;
          group.roi150 = group.roi150 / group.statCostSum / group.roi0;
        }

        // 删除临时字段
        delete group.statCostSum;
        delete group.count;

        return group;
      });

      console.log("分组结果:", result);
      return result;
    },
    customSort({prop, order}) {

      console.log(this.tableDataY4)
      // 分离合计行和其他数据
      const totalData = this.tableDataY4.filter(item => item.gameName === '合计')
      const normalData = this.tableDataY4.filter(item => item.gameName !== '合计')

      // 正常数据排序
      const sorted = normalData.sort((a, b) => {
        const aVal = a[prop]
        const bVal = b[prop]
        if (order === 'ascending') {
          return aVal > bVal ? 1 : -1
        } else {
          return aVal < bVal ? 1 : -1
        }
      })

      // 合并数据（合计行始终在首行）
      this.tableDataY4 = [...totalData, ...sorted]

      console.log(this.tableDataY4)
    },
    initChart() {
      this.chart = this.$echarts.init(this.$refs.chart)
      this.updateChart()
    },
    updateChart() {
      // 生成动态配置
      const options = this.generateChartOptions()
      this.chart.setOption(options, true)
    },

    generateChartOptions() {
      // 获取合计行数据（关键点1）
      const totalRow = this.tableDataY4.find(item => item.gameName === '合计')

      const mockData = this.tableDataY4.filter(item => item.gameName !== '合计').map(item => ({
        date: item.uploadDate,
        statCost: item.statCost || 0, // 消耗字段
        statCost2: (item.statCost - item.pfAmount) || 0,
        profit: ((Math.max(item.roi3, item.roi7, item.roi15, item.roi30, item.roi45, item.roi60, item.roi75, item.roi90) * item.roi0 - 1) * (item.statCost - item.pfAmount)).toFixed(2) || 0,
        ...this.roiDays.reduce((acc, day) => {
          acc[`roi${day}`] = item[`roi${day}`]
          acc[`roi${day}Percent`] = (item[`roi${day}`] * item.roi0 * 100).toFixed(2)
          return acc
        }, {})
      }))

      // 生成系列配置
      const seriesConfig = [
        // ROI系列（关键点2）
        ...this.selectedDays.map(day => {
          const series = {
            name: `${day}日ROI`,
            type: 'line',
            yAxisIndex: 0,
            data: mockData.map(item => item[`roi${day}Percent`]),
            itemStyle: {color: this.getColor(day)},
            smooth: true
          }

          // 当选中3日时添加markLine
          if (totalRow) {
            series.markLine = {
              silent: true, // 不触发事件
              symbol: 'none',
              lineStyle: {
                type: 'dashed',
                color: '#FF6B6B',
                width: 2
              },
              label: {
                show: true,
                position: 'start',
                formatter: `${day}day ${(totalRow['roi' + day] * totalRow['roi0'] * 100).toFixed(1)}%`
              },
              data: [{
                yAxis: (totalRow[`roi${day}`] * totalRow.roi0 * 100).toFixed(2) // 保持计算一致性
              }]
            }
          }
          return series
        }),// 新增：100% ROI基准线系列（关键修改点）

        {
          name: '100% ROI基准线',
          type: 'line',
          yAxisIndex: 0,
          data: [], // 空数据系列
          silent: true, // 不响应交互
          symbol: 'none',
          lineStyle: {
            opacity: 0 // 隐藏主线条
          },
          markLine: {
            symbol: 'none',
            lineStyle: {
              type: 'solid',
              color: '#666',
              width: 1
            },
            label: {
              show: true,
              position: 'start',
              formatter: '100% ROI'
            },
            data: [{
              yAxis: 100, // 固定值100%
              x: '0%' // 从最左侧开始
            }]
          }
        },

        // 倍率系列（关键点3）
        ...this.selectedDays.map(day => {
          const series = {
            name: `${day}日倍率`,
            type: 'line',
            yAxisIndex: 1,
            data: mockData.map(item => item[`roi${day}`]),
            itemStyle: {color: this.getColor(day)},
            lineStyle: {type: 'dashed'}
          }

          if (totalRow) {
            series.markLine = {
              silent: true,
              symbol: 'none',
              lineStyle: {
                type: 'dashed',
                color: '#4ECDC4',
                width: 2
              },
              label: {
                show: true,
                position: 'end',
                formatter: `${day}日合计 ${totalRow.roi3.toFixed(2)}`
              },
              data: [{
                yAxis: totalRow[`roi${day}`]
              }]
            }
          }
          return series
        }),

        // 消耗系列
        ...(this.showCost ? [{
          name: '消耗',
          type: 'bar',
          yAxisIndex: 2,
          data: mockData.map(item => item.statCost),
          itemStyle: {
            color: new this.$echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  {offset: 0, color: 'rgb(245,106,106)'}, // 添加透明度
                  {offset: 1, color: 'rgb(245,106,106)'}
                ]
            )
          },
          barWidth: '60%',
          z: 1,
          barGap: '-100%'// 确保在底部
        }] : []),
        // 实际消耗系列
        ...(this.showCost2 ? [{
          name: '实际消耗',
          type: 'bar',
          yAxisIndex: 2,
          data: mockData.map(item => item.statCost2),
          itemStyle: {
            color: new this.$echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  {offset: 0, color: 'rgb(105,239,147)'}, // 添加透明度
                  {offset: 1, color: 'rgb(105,239,147)'}
                ]
            )
          },
          barWidth: '60%',
          z: 2,
          barGap: '-100%'// 确保在底部
        }] : []),
        // 实际消耗系列
        ...(this.showCost3 ? [{
          name: '利润',
          type: 'bar',
          yAxisIndex: 2,
          data: mockData.map(item => item.profit),

          itemStyle: {
            color: 'transparent',
            borderColor: '#529be5',
            borderWidth: 1.5
          },
          barWidth: '60%',
          z: 3,
          barGap: '-100%' // 确保在底部
        }] : [])

      ]

      return {
        ...this.chartOptions,
        xAxis: {
          ...this.chartOptions.xAxis,
          data: mockData.map(d => d.date)
        },
        series: seriesConfig.filter(s => s),
        legend: {
          ...this.chartOptions.legend,
          data: seriesConfig.map(s => s?.name).filter(Boolean)
        }
      }
    },
    getColor(day) {
      // 按天数分配颜色
      const colorMap = {
        3: '#5470C6', 7: '#91CC75', 15: '#FAC858', 30: '#EE6666',
        45: '#73C0DE', 60: '#3BA272', 75: '#FC8452', 90: '#9A60B4'
      }
      return colorMap[day] || '#666'
    },


    getCellClass({column}) {

      console.log(column)
      if (column.prop === 'cAmount') {
        return 'table-number2'
      }
      return ''
    },
    get() {

      this.$axios
          .get('/toufang/data/getDefault?type=' + this.form.type, {})

          .then(successResponse => {

            if (successResponse.data.code === 200) {

              this.form.allDivisionScale = successResponse.data.data

            } else {

              this.$message({
                message: '发生错误请联系管理员。',
                type: 'warning'
              });

            }

          })
    },
    change() {


      this.$axios
          .post('/toufang/data/updateDefault', this.form)

          .then(successResponse => {

            if (successResponse.data.code === 200) {

              this.$message({
                message: '更新' + this.form.type + '默认值成功!',
                type: 'success'
              });
            } else {

              this.$message({
                message: '发生错误请联系管理员。',
                type: 'warning'
              });

            }

          })


    },
    formDate(date) {
      // 将Excel日期转换为JavaScript日期
      const jsDate = new Date((date - 25569) * 86400 * 1000);
      // 将JavaScript日期转换为指定格式：yyyy-MM-dd
      const year = jsDate.getFullYear();
      const month = String(jsDate.getMonth() + 1).padStart(2, '0');
      const day = String(jsDate.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    changeExcel(e) {
      const files = e.target.files
      if (files.length <= 0) {
        return false
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        console.log('上传格式不正确，请上传xls或者xlsx格式')
        return false
      }
      // 读取表格
      const fileReader = new FileReader()
      fileReader.onload = ev => {
        const workbook = this.$xlsx.read(ev.target.result, {
          type: "binary"
        })
        const wsname = workbook.SheetNames[0]
        const ws = this.$xlsx.utils.sheet_to_json(workbook.Sheets[wsname])
        console.log('ws:', ws) // 转换成json的数据
        //  dealExcel(ws) ...对数据进行自己需要的操作
        // table2.value = ws

        var tt = this


        ws.forEach(function (element) {

          tt.$axios
              .post("/toufang/data/addIn", {
                date: tt.formDate(element.日期),
                name: element.游戏名称,
                jl: element.激励政策收入,
                pf: element.平台赔付
              })
              .then(successResponse => {

                console.log(successResponse)

                if (successResponse.data.code === 200) {

                  this.$notify({
                    title: '成功',
                    message: "添加成功",
                    type: 'success'
                  });
                }


              }).catch((err) => {
            //请求失败的回调函数
            console.log(err)
            console.log('失败')
          })

        });


      }
      fileReader.readAsBinaryString(files[0])
    },
    edit() {

      this.$axios
          .post('/toufang/data/addBi', this.form)
          .then(successResponse => {

            if (successResponse.data.code === 200) {


              this.dialogFormVisible = false

              this.$message({
                message: '操作成功!',
                type: 'success'
              });
            } else {

              this.$message({
                message: '发生错误请联系管理员。',
                type: 'warning'
              });

            }

          })


    },
    indexMethod(index) {

      return index / 6 + 1;

    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex % 6 == 0) {
        return 'column-style2';
      } else {
        return 'column-style2';
      }
      // warning-row
    }, objectSpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 0 || columnIndex === 1) {
        if (rowIndex % 6 === 0) {
          return {
            rowspan: 6,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },

    // 表头部重新渲染
    renderHeader(h, {column, $index}) {
      // 新建一个 span
      let span = document.createElement('span');
      // 设置表头名称
      span.innerText = column.label;
      // 临时插入 document
      document.body.appendChild(span);
      // 重点：获取 span 最小宽度，设置当前列，注意这里加了 20，字段较多时还是有挤压，且渲染后的 div 内左右 padding 都是 10，所以 +20 。(可能还有边距/边框等值，需要根据实际情况加上)
      column.minWidth = span.getBoundingClientRect().width + 20;
      // 移除 document 中临时的 span
      document.body.removeChild(span);
      return h('span', column.label);

    },
    addProp() {

      this.newPropValue = ''

      if (!this.arr1.includes(this.valProp))
        this.arr1.push(this.valProp + '_')

      if (this.valProp2 != '') {

        this.arr1.push(this.valProp2)
      }
      if (this.valueSuan != '') {

        this.arr2.push(this.valueSuan)

      }


      for (let i = 0; i < this.arr1.length; i++) {
        console.log(this.arr1[i]);

        this.newPropValue = this.newPropValue + this.arr1[i]

        if (this.arr2.length > i)
          this.newPropValue = this.newPropValue + this.arr2[i]

      }


    },
    date_format_new() {

      let date1 = new Date();

      let year = date1.getFullYear();
      // alert(year)
      let month = date1.getMonth() + 1;
      let day = date1.getDate();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;

      this.value2 = year + '' + month + '' + day;


    },
    createExportData() {

      return this.json_data

    },


    getDiffDay() {
      let totalDays, diffDate
      let myDate_1 = Date.parse(this.value2)
      let myDate_2 = new Date()
      diffDate = Math.abs(myDate_1 - myDate_2)
      totalDays = Math.floor(diffDate / (1000 * 3600 * 24))
      this.value3 = totalDays + 1
    }, value_format5(row, column, value) {

      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return '-'

      } else {

        return value.toFixed(2)
      }
    },
    value_format(row, column, value) {
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return '-'

      } else if (value <= 0) {

        return '-'

      } else {
        value = Math.round(value / 100)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    }, value_format2(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return '-'

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    }, value_format4(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return '-'

      } else if (value <= 0) {

        return '-'

      } else {

        return value.toFixed(2) + '%'
      }
    }, value_format3(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "次日9点更新"
      } else if (isNaN(value)) {

        return '0'

      } else if (value <= 0) {

        return '0'

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    }, findGame() {

      this.$axios
          .get('/toufangWx/data/findName', {})
          .then(successResponse => {

            this.optionsGame = successResponse.data.data

          })


    }, changeGame() {


      if (this.valueGame !== "") {

        this.checkedYugu = ['游戏名', '日期']

      }

    }, handleClick(tab, event) {

      console.log(tab.name)

    },  // 重置列显示
    resetColumns() {
      this.visibleColumns = [
        'uploadDate', 'gameType', 'gameName', 'statCost', 'profit',
        'roiInfo', 'maxNonZeroDay', 'roi0', 'roiColumns', 'groupLabel'
      ];
    },

    // 检查列是否可见
    isColumnVisible(column) {
      return this.visibleColumns.includes(column);
    },

    // 切换列显示状态
    toggleColumn(column) {
      const index = this.visibleColumns.indexOf(column);
      if (index > -1) {
        this.visibleColumns.splice(index, 1);
      } else {
        this.visibleColumns.push(column);
      }
    },
    search(flag) {

      this.activeName ='first'

      if (flag) {

        console.log("手动选条件")

        localStorage.setItem("ToufangWxBroad", JSON.stringify({
          name: this.valueGame,
          date: this.value2,
          a: this.activeName,
          checkedCities: this.checkedCities,
          visibleColumns: this.visibleColumns
        }))

      } else {


        if (localStorage.getItem("ToufangWxBroad") != null) {

          console.log("自动刷")

          this.checkedCities = JSON.parse(localStorage.getItem("ToufangWxBroad")).checkedCities

          this.valueGame = JSON.parse(localStorage.getItem("ToufangWxBroad")).name

          this.value2 = JSON.parse(localStorage.getItem("ToufangWxBroad")).date

          this.activeName = JSON.parse(localStorage.getItem("ToufangWxBroad")).a==='4'?'first':JSON.parse(localStorage.getItem("ToufangWxBroad")).a

          this.visibleColumns = JSON.parse(localStorage.getItem("ToufangWxBroad")).visibleColumns || this.visibleColumns

        }
      }
      console.log("来了")

      if (this.activeName === '4') {
        if (this.valueGame !== "") {

          this.checkedYugu = ['游戏名', '日期']

        }
        this.$axios
            .post('/toufangWx/data/gameConfig/find', {})

            .then(successResponse => {

              this.tableDataType = successResponse.data.data

            }).catch((err) => {
          //请求失败的回调函数
          console.log(err)
          console.log('失败')
        })

        this.loading = true
        this.$axios
            .post('/toufangWx/data/findY4', {
              start: this.value2 == null ? '' : this.value2[0],
              cname: this.valueGame == null ? '' : this.valueGame,
              currentPage: this.currentPage4 == null ? 1 : this.currentPage4,
              end: this.value2 == null ? '' : this.value2[1],
              date: this.value5 == null ? '' : this.value5,
              type: this.yType == null ? '' : this.yType
            })
            .then(successResponse => {

              let filteredData = successResponse.data.data;
              if (this.gameType) {
                filteredData = filteredData.filter(item => {
                  return item && item.gameType === this.gameType;
                });
              }

              filteredData = this.groupData(filteredData)

              this.tableDataY4 = filteredData;

              this.tableDataY4 = filteredData;
// 将 descType 为 2 的数据单独取出
              const descType2Data = this.tableDataY4.filter(e => e.descType === 2);
// 处理非 descType 为 2 的数据
              const nonDescType2Data = this.tableDataY4.filter(e => e.descType !== 2);
// 对非 descType 为 2 的数据进行处理
              this.tableDataY4 = this.processRoiData(nonDescType2Data);

              this.tableDataY4 = [...this.tableDataY4, ...descType2Data];

              var b = {}

              b.gameName = '合计'


              b.uploadDate = '合计'
              b.statCost = 0

              b.pfAmount = 0

              b.roi0 = 0

              var arr = [1, 2,3,4,5,6 , 7, 15, 30, 45, 60, 75, 90]

              arr.forEach(function (f) {

                b['roi' + f] = 0

              })

              this.tableDataY4.filter(e => e.gameName !== '合计' && e.descType !== 2).forEach(function (e) {
                e.statCost = e.statCost == null ? 0 : e.statCost
                e.pfAmount = e.pfAmount == null ? 0 : e.pfAmount

                e.roi0 = e.roi0 * e.statCost / (e.statCost - e.pfAmount)
                e.roi0 = isNaN(e.roi0) ? 0 : e.roi0

                b.statCost += e.statCost
                b.pfAmount += e.pfAmount
                b.roi0 += e.roi0 * e.statCost

                arr.forEach(function (f) {
                  b['roi' + f] += e['roi' + f] * e.statCost * e['roi0']
                })
              })


              arr.forEach(function (f) {

                b['roi' + f] /= b.roi0
                b['roi' + f] = isNaN(b['roi' + f]) ? 0 : b['roi' + f]
              })

              b.roi0 /= b.statCost - b.pfAmount

              b.roi0 = isNaN(b.roi0) ? 0 : b.roi0

              this.tableDataY4.unshift(b)

              console.log("合计数据:", b)

              this.tableDataY4 = this.tableDataY4.filter(item => {

                return item.statCost > 0;
              })
              this.loading = false

              if (this.showChart === true) {

                this.initChart()
              }


            })


      } else {
        this.maxHeight = window.innerHeight - 250;
        if (this.value2 != null && this.value2 !== '') {

          this.tableData = []
          this.loading = true
          var a = {}
          a['adConsume'] = 0
          a['adBi'] = 0
          a['incomBefore'] = 0
          a['gameName'] = '总计'
          a['uploadDate'] = '总计'
          a['profit'] = 0
          a['costAmout'] = 0

          a['ygProfit'] = 0
          a['ygROI'] = 0
          a['实时利润'] = 0
          this.$axios
              .get('/toufangWx/data/find/' + this.value2[0] + "/" + this.value2[1] + "?name=" + this.valueGame + "&param=" + this.checkedCities, {})
              .then(successResponse => {

                successResponse.data.data.forEach(function (e) {
                  e['profit'] = e.incomBefore + e.adBi - e.adConsume


                  e['ygProfit'] = e.adRoi150 * (parseFloat(e.adRoi1) + parseFloat(e.adRoi2)) - parseFloat(e.adConsume)
                  e['ygROI'] = e.adRoi150 * (parseFloat(e.adRoi1) + parseFloat(e.adRoi2)) / parseFloat(e.adConsume) * 100
                  e['首日roi'] = (parseFloat(e.adRoi1) + parseFloat(e.adRoi2)) / parseFloat(e.adConsume) * 100

                  a['ygProfit'] = a['ygProfit'] + parseFloat(e.ygProfit == null ? 0 : e.ygProfit)

                  e['实时利润'] = parseFloat(e.adRoi135) - parseFloat(e.adConsume)

                  a['实时利润'] = a['实时利润'] + e['实时利润']

                  e['实时roi'] = parseFloat(e.adRoi135) / parseFloat(e.adConsume) * 100

                  e['实时倍率'] = parseFloat(e.adRoi135) / (parseFloat(e.adRoi1) + parseFloat(e.adRoi2))


                  a['adConsume'] = a['adConsume'] + e.adConsume

                  a['costAmout'] = a['costAmout'] + e.costAmout
                  a['adBi'] = a['adBi'] + e.adBi
                  a['profit'] = a.profit + e.profit
                  a['incomBefore'] = a['incomBefore'] + e.incomBefore
                })

                this.tableData.push(a)

                this.tableData = this.tableData.concat(successResponse.data.data)

                this.loading = false


              })

        }
      }
    },processRoiData(data) {
      // 对于每个 roi 天数，检查是否有任意一项为 0
      const processedData = [...data];


      if (this.valueGame !== '') {
        // 检查每个 roi 字段是否含有 0 值
        this.roiDays.forEach(day => {
          const hasZero = processedData.some(item =>
              item[`roi${day}`] === 0
          );

          // 如果存在 0 值，则将所有该项设为 0
          if (hasZero) {
            processedData.forEach(item => {
              item[`roi${day}`] = 0;
            });
          }
        });

      }
      processedData.forEach(item => {
        if (item.descType === 1) {
          // 找到 roi3 在 roiDays 中的索引
          const startIndex = this.roiDays.indexOf(3);
          // 如果找到了 roi3，则将它及之后的所有 ROI 设置为 0
          if (startIndex !== -1) {
            for (let i = startIndex; i < this.roiDays.length; i++) {
              const day = this.roiDays[i];
              item[`roi${day}`] = 0;
            }
          }
        }


        // 计算最大非零天数
        let maxDay = 0;
        for (let i = this.roiDays.length - 1; i >= 0; i--) {
          const day = this.roiDays[i];
          if (item[`roi${day}`] !== 0 && item[`roi${day}`] !== undefined) {
            maxDay = day;
            break;
          }
        }
        item.maxNonZeroDay = maxDay;

      });
      return processedData;
    },

  }
  , updated() {

    this.$nextTick(() => {
      this.$refs['tableData1'].doLayout();
    })

  },
  mounted: function () {

    this.height = window.innerHeight;
    // this.date_format_new()
    this.findGame()
    // this.search()

    this.search(false)
  }


}
</script>
<style>

</style>
<style type="text/css">

*::-webkit-scrollbar {
  width: 5px;
  height: 12px;
  background-color: transparent;
}

.bbb {
  //box-shadow: rgba(148,148,148,0.34) 0px 1px 3px 1px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .08);
  padding: 24px;
  border-radius: 8px;
  background-color: #FFFFFF;
  width: 98%;
  //margin-left: 2%;

  min-height: 80vh;
}

</style>


<style scoped>


.red {

  color: #d65055;

}

.green {

  color: #5daf34;
}

.chart-container {
  padding: 20px;
  width: 97%;
  background: white;
  border-radius: 8px;

  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 改变input框背景颜色 */
/deep/ .el-input__inner {
  background-color: rgba(240, 240, 240, 0.94);

}

/deep/ .el-range-input {
  background-color: rgba(240, 240, 240, 0.94);

}
</style>